import { BENEFICIARY_MODAL_REASON } from "./beneficiaryModalReason";

const TPH_COPY = {
    descriptionKey: "transfer.foreign.beneficiary.modal.edit.text",
    confirmLabelKey: "transfer.foreign.beneficiary.modal.edit.button",
    showCancel: true,
    backdrop: true,
};

const IBAN_COPY = {
    descriptionKey: "transfer.foreign.beneficiary.modal.editIban.text",
    confirmLabelKey: "transfer.foreign.beneficiary.modal.editIban.button",
    showCancel: false,
    // Prevent outside click from dismissing / firing CTA via onHide → accept
    backdrop: "static",
};

/**
 * Maps modalReason to ConfirmDialog copy and cancel/backdrop policy.
 *
 * @returns {{ descriptionKey: string, confirmLabelKey: string, showCancel: boolean, backdrop: boolean|string } | null}
 */
export const getBeneficiaryModalCopy = (reason) => {
    if (reason === BENEFICIARY_MODAL_REASON.IBAN_REQUIRED) {
        return IBAN_COPY;
    }

    if (reason === BENEFICIARY_MODAL_REASON.INCOMPLETE_DETAILS || !reason) {
        return TPH_COPY;
    }

    return null;
};
